export const LANDING_PAGE_PATH = "/";
export const HOME_PATH = "/app";
export const GENERATE_PATH = "/app/generate";
export const MAGIC_PATH = "/app/generate?mode=magic";
export const ADVANCED_PATH = "/app/generate?mode=advanced";
export const FEED_PATH = "/app/feed";
export const LIBRARY_PATH = "/app/library";

export const PROFILE_PATH = "/app/profile";
export const LEADERBOARD_PATH = "/app/leaderboard";

export const INPAINTING_PATH = "/app/inpainting";
export const FOLDERS_PATH = "/app/library/folders";
export const CHAT_PATH = "/app/chat";
export const CHAT_CONVERSATION_PATH = `${CHAT_PATH}/conversation`;
export const CHAT_LIST_PATH = `${CHAT_PATH}/list`;